import * as types from './types'
import Cookies from 'js-cookie'

const state = {
  fetched: true,
  title: null,
  type: null,
  name: null,
  id: Cookies.get('id'),
  logo: null,
  withdraw_min_amount: null,
}

const mutations = {
  [types.FETCHED]: (state) => {
    state.fetched = false
  },
  [types.SET]: (state, { title, type, name, id, logo, withdraw_min_amount }) => {
    Cookies.set('id', id)
    Object.assign(state, {
      title,
      type,
      name,
      id,
      logo,
      withdraw_min_amount,
    })
  },
}

export default {
  namespace: true,
  state,
  mutations,
}
